import styles from './HeadingAndIcon.module.css';

const HeadingAndIcon = ({
  icon,
  heading,
  color,
  NoBgIcon,
  bgColor = 'rgba(from var(--Info_Color) r g b / 0.3)',
}) => {
  return (
    <div className={styles.container}>
      {icon && (
        <div className={styles.iconCircle} style={{ backgroundColor: bgColor }}>
          {icon}
        </div>
      )}
      {NoBgIcon && <span>{NoBgIcon}</span>}

      <p className={styles.label} style={{ color }}>
        {heading}
      </p>
    </div>
  );
};

export default HeadingAndIcon;
